import {
    AimOutlined,
    BarChartOutlined,
    CalendarOutlined,
    ContactsOutlined,
    DownloadOutlined,
    ShoppingFilled,
    AccountBookFilled,
    AlertFilled,
    WeiboCircleFilled,
    FileTextOutlined,
    FileProtectOutlined,
    SaveFilled,
    FieldTimeOutlined,
    AudioFilled,
    GoldFilled,
    LeftCircleFilled,
    BankFilled
  } from '@ant-design/icons';
import { Theme } from '@mui/material';

const colors = {
    ash: "#d6e1eba9",
    ash2: "#606163",
    appYellow: "#dba620",
    error: "bg-danger",
    success: "bg-success",
    warning: "bg-warning",
    danger: "#ff0000",
    white: "#fff",
    sideNav: "#1f2d3d",
    sideNavDark: "#070c11",
    black: "#000",
    primaryBlue: "#1677ff",
    restaurantTrayColor: `rgb(68, 68, 116), rgb(170, 89, 89))`
}

export const colorPalleteArray = (theme: Theme) =>{
    return [
       {color: theme.palette.secondary.darker, iconPrimary: BarChartOutlined},
       {color: theme.palette.error.darker, iconPrimary: CalendarOutlined},
       {color: theme.palette.success.darker, iconPrimary: FileTextOutlined},
       {color: theme.palette.primary.darker, iconPrimary: DownloadOutlined},
       {color: theme.palette.info.darker, iconPrimary: ShoppingFilled},
       {color: theme.palette.warning.darker, iconPrimary: FileProtectOutlined},
       {color: theme.palette.grey[900], iconPrimary: AlertFilled},
       {color: theme.palette.primary.darker, iconPrimary: WeiboCircleFilled},
       {color: theme.palette.success.darker, iconPrimary: AccountBookFilled},
       {color: theme.palette.warning.darker, iconPrimary: FieldTimeOutlined},
       {color: theme.palette.secondary.darker, iconPrimary: BarChartOutlined},
       {color: theme.palette.error.darker, iconPrimary: CalendarOutlined},
       {color: theme.palette.success.darker, iconPrimary: FileTextOutlined},
       {color: theme.palette.primary.darker, iconPrimary: AimOutlined},
       {color: theme.palette.info.darker, iconPrimary: ShoppingFilled},
       {color: theme.palette.success.darker, iconPrimary: ContactsOutlined},
       {color: theme.palette.secondary.darker, iconPrimary: AlertFilled},
       {color: theme.palette.warning.darker, iconPrimary: WeiboCircleFilled},
       {color: theme.palette.warning.darker, iconPrimary: AccountBookFilled},
       {color: theme.palette.error.darker, iconPrimary: DownloadOutlined},
       {color: theme.palette.primary.darker, iconPrimary: WeiboCircleFilled},
       {color: theme.palette.error.darker, iconPrimary: BankFilled},
       {color: theme.palette.grey[900], iconPrimary: AlertFilled},
       {color: theme.palette.error.darker, iconPrimary: AudioFilled},
       {color: theme.palette.error.darker, iconPrimary: CalendarOutlined},
       {color: theme.palette.success.darker, iconPrimary: FileTextOutlined},
       {color: theme.palette.primary.darker, iconPrimary: LeftCircleFilled},
       {color: theme.palette.info.darker, iconPrimary: GoldFilled},
       {color: theme.palette.primary.darker, iconPrimary: AimOutlined},
       {color: theme.palette.success.darker, iconPrimary: SaveFilled},
     ];

};

export default colors;